import ApiUtil from "@/api/api.util"
import ApiConfig from "@/api/api.config"


const platformDomain = ApiConfig.platformDomain

const makeDynamicMultiColumns = function(maxDeptLevel) {
  let currentDeptColumns = new Array()
  let currentColumnWidth

  if(maxDeptLevel > 2) {
    currentColumnWidth = 150
  }

  for(let i=0; i <= maxDeptLevel; i++) {
    let displayNumber = i+1

    currentDeptColumns.push({
      field: `deptNm_${i}`,
      title: `부서${displayNumber}`,
      template : `<span style="font-size: 11pt; padding-right: 15px; " title="#:deptNm_${i}#">#:deptNm_${i}#</span>`,
      headerTemplate: `<span style="font-weight: bold;">부서${displayNumber}</span>`,
      width: currentColumnWidth
    })

  }

  return currentDeptColumns
}

const getMultiColumnDeptData = function(params, afterFunc) {
  const url = `${platformDomain}/v1/ebmp/main/dept/multiColumnDeptList.json`

  // const params = {
  //   loginUserToken : sessionStorage.getItem('loginUserToken'),
  //   cmpyCd : sessionStorage.getItem('sessionUserCmpyCd')
  // }

  ApiUtil.post(url, params)
    .then(response => {
      if(response.data === undefined || response.data.resultStatus === undefined) {
        kendo.alert("데이터를 정상적으로 받아오지 못했습니다.");

        return false
      }

      const resultStatus = response.data.resultStatus

      if(resultStatus.messageCode !== "2000"){
        kendo.alert(resultStatus.messageText)

        return false
      }

      const resultData = response.data.resultData

      if(afterFunc) {
        afterFunc(resultData)
      }

    })
}

const addClickEventForClearIcon = function(targetId, afterFunc) {
  if(targetId === undefined || targetId === null || targetId === "") {
    return
  }

  //클린코드에서 말하는 기차 충돌 형식의 나쁜 코드이지만 결과가 명확하므로 사용한다.
  const kendoMultiColumnComboboxClearElements = document.getElementById(targetId).parentElement.firstChild.children

  console.log(`kendoMultiColumnComboboxClearElements !! : ${kendoMultiColumnComboboxClearElements}`)

  if(kendoMultiColumnComboboxClearElements === undefined || kendoMultiColumnComboboxClearElements === null) {
    return
  }

  if(afterFunc === undefined) {
    return
  }

  for(let i=0; i < kendoMultiColumnComboboxClearElements.length; i++) {
    const tempChild = kendoMultiColumnComboboxClearElements[i]

    console.log(`tempChild : ${tempChild}`)

    if(tempChild.className.indexOf('k-i-close') != -1) {
      if(afterFunc) {
        tempChild.onclick = afterFunc
      }
    }
  }

}

export default {
  makeDynamicMultiColumns,
  getMultiColumnDeptData,
  addClickEventForClearIcon
}
